import React from "react";
import searchicon from "./assets/searchicon.svg";
import writeicon from "./assets/writereview.svg";
import submiticon from "./assets/submit.svg";
import vendorbg from "./assets/vendorbg.png";
import { useNavigate } from "react-router-dom";
import VendorCTA from "./VendorCTA";

const HowToRate = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center w-full">
      <h1 className="font-bold text-lg xl:text-[24px] mb-7">
        How to Rate a Vendor
      </h1>

      {/* 🧭 Steps Container */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-7 md:gap-10 mb-[9px] xl:mb-[52px] rounded-t-[30px] w-full">
        {/* Step 1 */}
        <div className="flex flex-col gap-[5px] items-center text-center mt-[10px]">
          <div className="rounded-full flex items-center justify-center text-white">
            <img src={searchicon} alt="Search" className="w-10 h-10" />
          </div>
          <h3 className="font-bold text-[24px] md:text-[20px] lg:text-[24px]">Search for vendor</h3>
          <p className="text-gray-400 text-sm">
            Enter vendor country, category and name to find the vendor
          </p>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col gap-[5px] items-center text-center mt-[10px] ">
          <div className="rounded-full flex items-center justify-center text-white">
            <img src={writeicon} alt="Write" className="w-10 h-10" />
          </div>
          <h3 className="font-bold text-[24px] md:text-[20px] lg:text-[24px] ">Write your review</h3>
          <p className="text-gray-400 text-sm">
            Write your review and enter any required information needed
          </p>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col gap-[5px] items-center text-center  mt-[10px]">
          <div className="rounded-full flex items-center justify-center text-white">
            <img src={submiticon} alt="Submit" className="w-10 h-10" />
          </div>
          <h3 className="font-bold text-[24px] md:text-[20px] lg:text-[24px] ">Submit</h3>
          <p className="text-gray-400 text-[16px]">
            Review every information and submit
          </p>
        </div>
      </div>

      {/* ✅ Vendor CTA Section */}
      <VendorCTA />
      </div>
    // </div>
  );
};

export default HowToRate;
